/**
 * PanelHeader - Shared panel header component
 *
 * Used across configuration pages for consistent styling.
 * Displays a title with an accent bar and optional action buttons.
 */

import { Box, Group, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface PanelHeaderProps {
  title: string;
  /** Accent colour for the left bar indicator */
  accentColour?: string;
  /** Optional action buttons or controls */
  children?: ReactNode;
}

export function PanelHeader({ title, accentColour = 'var(--blue-accent)', children }: PanelHeaderProps) {
  return (
    <Box
      style={{
        backgroundColor: 'var(--bg-base)',
        borderBottom: '1px solid var(--border-colour)',
        padding: '0.75rem 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
      }}
    >
      <Group gap={8}>
        <Box
          style={{
            width: 3,
            height: 16,
            backgroundColor: accentColour,
            borderRadius: 2,
          }}
        />
        <Text
          style={{
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: 'var(--text-secondary)',
          }}
        >
          {title}
        </Text>
      </Group>
      {children}
    </Box>
  );
}
